import React, { useState, useEffect } from 'react';
import { collection, getDocs} from "firebase/firestore"; 
import { db } from "../firebase-config";
import Financeurs from "./Financeurs"

const MurDesOffres = () => {

    const [offer, setOffer] = useState([])


    useEffect(() =>  {
        setOffer([]);
        loadOfferData();
      
    }, []);

    const loadOfferData = async () =>  {
  
  
        const ref = collection(db, 'offreDemploi');
        const querySnapshot = await getDocs(ref)
        querySnapshot.forEach((doc) => {
         
            setOffer(offer => [doc.data(), ...offer])
           
        }) 
    
    }


    return (
        <div>

            <div className="container">
                {offer.map( item => (
                    <div className="offer">
                       <h2>{item.INTITULE}</h2>     
                       <h4>Organisme :</h4>     
                       <span>{item.STRUCTURE}</span>
                       <h4>Type de Contrat : </h4>
                       <span>{item.CONTRAT}</span> 
                       <div className="mission">
                        <h4>La Mission :</h4>  
                        <p>{item.MISSION}</p>
                       </div>  
                       <h4>Compétences requises :</h4>     
                       <span>{item.COMPETENCES}</span> 
                       <h4>Conditions Particulières : </h4>    
                       <span>{item.CONDITIONS}</span> 
                       <h4>Contact : </h4>     
                       <span>{item.CONTACT}</span>  
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MurDesOffres;